.form {
	display: flex;
	flex-direction: column;
	gap: var(--size-4);
}

.label {
	display: flex;
	align-items: center;
	gap: var(--size-3);
}

.blurb {
	font-size: var(--text-caption);
	color: var(--color-text-subtle);
}

.error {
	color: var(--color-error-text);
	font-size: var(--text-caption);

	&:empty {
		display: none;
	}
}

.adjacent {
	display: grid;
	grid-template-columns: 1fr min-content;
	gap: var(--size-3);
	align-items: center;
}

.actions {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: flex-end;
	gap: var(--size-3);
}

.profileSub {
	font-size: var(--text-caption);
}

.copyId {
	border: none;
	border-radius: var(--radius-lg);
	padding: var(--size-2) var(--size-3);
	align-self: flex-end;
	font-family: var(--font-mono);
	background-color: transparent;
	font-size: var(--text-caption);
	color: var(--color-text-silent);

	&:hover {
		background-color: rgb(from var(--color-surface) r g b / 50%);
	}
}
